/*

    * main.ts
    Svelte's root entry for running the app
    ? DO NOT touch this file unless you know what you are doing.

*/
import App from './App.svelte';
const app = new App({
    target: document.body
});
export default app;
